import React from 'react'

export default function EmptyFolderIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.7085 9.50098H10.5928L9.35059 8.25879C9.07617 7.98486 8.7124 7.83398 8.3252 7.83398H4.29199C3.02881 7.83496 2.00098 8.86328 2.00098 10.126V19.7095C2.00098 20.9731 3.02881 22.0005 4.29199 22.0005H19.7075C20.9717 22.0005 21.9995 20.9731 21.9995 19.7095V11.7935C21.9995 10.5293 20.9717 9.50098 19.7085 9.50098Z" fill="#B1AEC7"/>
            <path d="M8.32465 6.43329C9.08588 6.43329 9.80121 6.73016 10.3398 7.26825L11.1723 8.10028H19.4995V4.29114C19.4995 3.02747 18.4719 2 17.2083 2H6.79242C5.52747 2 4.5 3.02747 4.5 4.29114V6.43329H8.32465Z" fill="#ECEBF7"/>
        </svg>
    )
}
